import {
  AlertScopeType,
  DisconnectionAlertLogsResponse,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseDisconnectionAlertLogsParams {
  alertSettingId?: number
  scopeType?: AlertScopeType
  scopeId?: number
  startDate?: string // 格式 "YYYY-MM-DD"
  endDate?: string // 格式 "YYYY-MM-DD"
  limit?: number
  offset?: number
  enabled?: boolean
}

/**
 * 查詢斷線警示發送紀錄
 */
export function useDisconnectionAlertLogs({
  alertSettingId,
  scopeType,
  scopeId,
  startDate,
  endDate,
  limit = 50,
  offset = 0,
  enabled = true,
}: UseDisconnectionAlertLogsParams = {}) {
  const { token } = useAuth()

  const queryParams = new URLSearchParams()
  if (alertSettingId !== undefined) queryParams.append('alert_setting_id', String(alertSettingId))
  if (scopeType) queryParams.append('scope_type', scopeType)
  if (scopeId !== undefined) queryParams.append('scope_id', String(scopeId))
  if (startDate) queryParams.append('start_date', startDate)
  if (endDate) queryParams.append('end_date', endDate)
  queryParams.append('limit', String(limit))
  queryParams.append('offset', String(offset))

  const shouldFetch = enabled && token

  const { data, error, mutate } = useGet<DisconnectionAlertLogsResponse>(
    shouldFetch ? `/api/disconnection-alert/logs?${queryParams.toString()}` : null,
    undefined,
    token ?? '',
  )

  return {
    logs: data?.data ?? [],
    total: data?.total ?? 0,
    isLoading: shouldFetch && !error && !data,
    isError: error,
    mutate,
  }
}
